(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupGalleries = (scope = document) => {
      const galleries =
        scope instanceof Element && scope.matches('.coming-soon-gallery')
          ? [scope]
          : scope.querySelectorAll('.coming-soon-gallery');

      galleries.forEach((gallery) => {
        if (gallery.dataset.controlsReady === 'true') return;

        const track = gallery.querySelector('.coming-soon-gallery__track');
        const previous = gallery.querySelector('.coming-soon-gallery__button--previous');
        const next = gallery.querySelector('.coming-soon-gallery__button--next');

        if (!track || !previous || !next) return;

        const updateButtons = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = maxScroll <= 1 || track.scrollLeft <= 1;
          next.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
        };

        const move = (direction) => {
          const firstItem = track.querySelector('.coming-soon-gallery__item');
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = (firstItem?.getBoundingClientRect().width || track.clientWidth) + gap;
          track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons, { passive: true });
        gallery.dataset.controlsReady = 'true';
        requestAnimationFrame(updateButtons);
      });
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-coming-soon-countdown]').forEach((timer) => {
        const end = Date.parse(timer.dataset.countdownEnd);
        const remainingSeconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;
        const values = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0'));

        timer.setAttribute('aria-label', values.join(':'));
        timer.textContent = values.map((value) => value.replace(/0/g, '•')).join(':');
      });
    };

    const startCountdowns = () => {
      updateCountdowns();
      if (window.__byblessedComingSoonInterval) {
        window.clearInterval(window.__byblessedComingSoonInterval);
      }
      window.__byblessedComingSoonInterval = window.setInterval(updateCountdowns, 1000);
    };

    const initialize = () => {
      setupGalleries();
      startCountdowns();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      setupGalleries(event.target);
      startCountdowns();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--announcement-banner-4"] && !Shopify.designMode) return;
  try {
    
const duplicateBannerContent = () => {
  const parents = document.querySelectorAll('[banner-data="parent"]');
  
  if (parents.length === 0) return;
  
  for (const parent of parents) {
    const child = parent.querySelector('[banner-data="duplicate"]');
    if (!child) continue;
    
    if (parent.children.length >= 2) continue;
    
    const duplicate = child.cloneNode(true);
    parent.appendChild(duplicate);
  }
};

// Handle initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', duplicateBannerContent);
} else {
  duplicateBannerContent();
}

// Handle theme editor changes
document.addEventListener('shopify:section:load', duplicateBannerContent);
document.addEventListener('shopify:section:reorder', duplicateBannerContent);

  } catch(e) { console.error(e); }
})();
})();
